
import React, { useState } from 'react';
import DashboardHeader from '@/components/dashboard/DashboardHeader';
import MetricsGrid from '@/components/dashboard/MetricsGrid';
import DashboardCharts from '@/components/dashboard/DashboardCharts';
import ActivitySection from '@/components/dashboard/ActivitySection';

const Index = () => {
  const [dashboardView, setDashboardView] = useState("cfo");

  return (
    <div className="space-y-6">
      <DashboardHeader 
        dashboardView={dashboardView} 
        setDashboardView={setDashboardView} 
      />
      <MetricsGrid />
      <DashboardCharts />
      <ActivitySection />
    </div>
  );
};

export default Index;
